/**
 * Gestion du formulaire de postulation /postuler
 */
import './form';

//todo refactoring prefill
(function (w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({}, w.Completude, {
        formApply: {
            data: {},
            $form: null,
            formStepGTM: [
                'index',
                'VotreSituation',
                'VotreCursus',
                'AnneeDetudeEnCours',
                'VotreEcole',
                'Diplome',
                'DernierDiplome',
                'MatieresChoisies',
                'DisposeVoiture',
                'Coordonnees',
                'Confirmation',
                'Error'
            ],
            /** Steps */
            steps: null,
            //on conserve l'historique pour les retours en arrière
            //car comme on saute des étapes en fonction des choix
            stepsHistory: [],

            /**
             * Initalisation du module
             */
            init: function () {
                /**
                 * Validation des niveaux cochés si subjet coché (form postuler, step subjects)
                 * Les enfants doivent avoir une classe correspondant au name du parent
                 * @see wp-content/themes/completude/components/apply/partials/subjects.php
                 */
                Parsley.addValidator('checkchildren', {
                    requirementType: 'integer',
                    validate: function (_value, requirement, instance) {
                        let fieldName = instance.$element.prop('name');
                        let checkedChild = jQuery('.' + fieldName + ':checked').length;

                        if (checkedChild >= requirement) {
                            if (!instance.$element.parent().hasClass('open')) {
                                instance.$element.parent().addClass('open')
                            }
                            //jQuery(instance.$element.parent()).find('.list-checkboxes .checkbox').removeClass('error');
                            return true;
                        } else {
                            if (instance.$element.parent().hasClass('open')) {
                                instance.$element.parent().removeClass('open')
                            }
                            //jQuery(instance.$element.parent()).find('.list-checkboxes .checkbox').addClass('error');
                            return false;
                        }
                    }
                });

                Parsley.addValidator('subjectRequired', {
                    requirementType: 'integer',
                    validateNumber: function (value, requirement) {
                        let checkboxs = jQuery('[name^="subjects"]');
                        let $return = false;
                        checkboxs.each((i, el) => {
                            let checkbox = jQuery(el);
                            if (checkbox.is(':checked')) {
                                $return = true;

                                if (checkbox.hasClass('subSubjectVerif') && !jQuery('[data-target="#collapsed-content1"]').hasClass('active')) {
                                    jQuery('[data-target="#collapsed-content1"]').click();
                                    $([document.documentElement, document.body]).animate({
                                        scrollTop: checkbox.offset().top - 200
                                    }, 2000);
                                }
                            }
                        })
                        return $return;
                    },
                    messages: {
                        fr: 'Merci de choisir au moins une matière'
                    }
                });


                Completude.formApply.$form = Completude.SetFormValidation($('#form-postuler'));

                this.prefillForm();
                // Active la gestion des étapes (library Steps.js)
                Completude.formApply.steps = new Steps({
                    steps: '[data-step-index]',
                    progress: '.progress-step',
                    progressIndex: 'data-step-progress-index',
                    container: document.querySelector('#apply-container'),
                    backNavigator: true
                });

                // Click pour passer à l'étape suivante
                $('#form-postuler .btn-step-next').on('click', function (event) {
                    event.preventDefault();
                    let $this = $(this);
                    if (Completude.formApply.parsleyValidateGroup($this.data('step'))) {
                        Completude.formApply.applyLocalStorage();
                        if ($this.hasClass('submit-end')) {
                            Completude.formApply.Postuler(Completude.formApply.$form.$element);
                            //Completude.formApply.moveToNext($this.data('submit-end'));
                        } else {
                            Completude.formApply.moveToNext($this.data('move-to'));
                        }
                    }
                });

                //Click pour passer à l'étape précédente
                $('#form-postuler .btn-step-back').on('click', function (event) {
                    event.preventDefault();
                    Completude.formApply.moveToPrevious();
                });

                //Click sur une liste de données type data-mappgin (déclenche le passage à l'étape suivante)
                $('[data-mapping]').on('click', function (event) {
                    event.preventDefault();
                    Completude.formApply.mappingFormApply(this);
                });

                //au changement d'état d'un subjects, on force la validation du champ
                $('[data-step-index="7"] .checkbox-items input[type="checkbox"]').on('change', function (event) {
                    let idSubject = $(event.target).prop('id').split('-');
                    idSubject = idSubject[idSubject.length - 1];
                    jQuery('#field-' + idSubject).parsley().validate();
                })

                //Changement d'un main subject
                $('[data-step-index="7"] input.mainSubject').on('change', function () {
                    $('input[name="subjectRequired"]').val($('[data-step-index="7"] input.mainSubject:checked').length);
                })

                // Matières : si la matière est déselectionné, vide les sous champs (Primaire, Collège...)
                jQuery('input[name^=subjects_]').on('change', function (object) {
                    let input = jQuery(jQuery(object)[0].target);

                    if (!input.is(':checked')) {
                        let parent = input.parent();
                        parent.find('.checkbox-items input').prop("checked", false);
                        parent.removeClass('open');
                    }
                })

                // Capte l'évènement "Chargement de l'agence"
                jQuery(document).on("agenceLoaded", "", function (event, agence) {
                    if (agence != null) {
                        w.Completude.formApply.AffficheMessageNouvellesAgence(agence);

                        if (jQuery('.nouvelle-agence').length > 0 && typeof (Completude.agence.Libelle) !== 'undefined') {
                            let html = jQuery('.nouvelle-agence').html();
                            jQuery('.nouvelle-agence').html(
                                html.replace('[ville_agence]', Completude.agence.Libelle)
                            )
                        }
                    }
                });

                //Envoi de l'étape 1 du tunnel KPI
                Completude.TagManagerTunnel();


            },

            parsleyValidateGroup: function (group) {
                return Completude.formApply.$form.validate({ group: 'apply_' + group });
            },

            /**
             * Comme les étapes ne se suivent pas, on se place :
             * soit par "next"
             * soit à un index donné
             * soit on valide le form
             * @param index
             */
            moveToNext: function (index) {
                if (index === 'submit-end') {
                    Completude.formApply.Postuler(Completude.formApply.$form.$element);
                    return;
                } else if (index === 'error') {
                    $('#apply-container').addClass('hide');

                    if (jQuery('#field-title-women').is(':checked')) {
                        $('#apply-error-kinougarde').removeClass('hide');
                        Completude.TagManagerTunnel('postuler/step-profil-kinougarde');
                    }
                    else {
                        $('#apply-error').removeClass('hide');
                        Completude.TagManagerTunnel('postuler/step-profil-ko');
                    }

                    index = 11;
                    return;
                } else if (index !== 'next') {
                    this.steps.to(index);
                } else {
                    this.steps.next();
                }

                jQuery('.nouvelle-agence').addClass('hide');
                Completude.TagManager('postuler', Completude.formApply.formStepGTM[index]);
                Completude.TagManagerTunnel();

            },

            moveToPrevious: function () {

                this.steps.prev();

            },

            /***
             *  Envoie des informations du formulaire postuler
             * @param currentForm
             */
            Postuler: function (currentForm) {
                var dataPostuler = $.extend(Completude.formApply.data, Completude.GetGlobalUtmFields());

                let id = $('#form-apply').data('id');

                if (id != -1 && Number.isInteger(id)) {
                    dataPostuler.jobId = id;
                }

                dataPostuler = Object.assign(Completude.formApply.data, window.autocomplete.localisation, {
                    action: 'ajax_postuler',
                    url: document.location.href
                });

                $('.form__steps [data-step-index="9"] .form__step-content').loading(
                    $.ajax({
                        url: disko_ajax_object.ajaxurl,
                        type: 'post',
                        data: dataPostuler,
                        success: function success(response) {
                            if (response.success) {
                                w.Completude.InitHtmlComponent();
                                Completude.UpdateAgence(response.data.agency.Id);

                                // Gestion du candidat ciblé ou non
                                if (response.data.priority === true) {
                                    $('#candidat_cible').removeClass('hide');
                                } else {
                                    $('#candidat_non_cible').removeClass('hide');
                                }
                                //Gestion de l'heure d'ouverture de l'agence
                                if (!Completude.isCompletudeOpen(Completude.agence)) {
                                    // Ce n'est pas ouvert, on supprime les message avec la classe ouvert
                                    $('#candidat_cible .ouvert').remove();
                                }
                                // Mise à jour du lien prendre RDV
                                $("#btn_prendre_rdv").attr("href", "/mon-rendez-vous/" + response.data.key + "/");

                                Completude.SetStorage('form-postuler', Completude.formApply.data);
                                // Enregistre la clé de securité
                                Completude.SetStorage('postuler-security-key', response.data.key, 7);

                                // Enregistre les offres qui ont déjà été postulées
                                if (Completude.formApply.data.jobId) {
                                    let appliedOffers = JSON.parse(Completude.GetStorage('applied_offers'));
                                    if (null === appliedOffers || -1 === appliedOffers.indexOf(Completude.formApply.data.jobId)) {
                                        appliedOffers = (appliedOffers || []).concat([Completude.formApply.data.jobId])
                                    }

                                    Completude.SetStorage('applied_offers', JSON.stringify(appliedOffers), 7);
                                }

                                $('.form__head').hide();
                                $('.progress-steps').hide();
                                $('h5.title,h6.title').hide();
                                $('.nouvelle-agence').hide();
                                Completude.formApply.moveToNext(10)

                            } else {
                                $('#apply-container').hide();
                                $('.loader').hide();
                                $('.error-noJob').removeClass('hide');
                            }
                            return false;
                        }
                    }).promise()
                );
            },

            /**
             * Au clic sur une liste d'élément
             * @param element
             */
            mappingFormApply: function (element) {
                let $element = $(element);

                $element.closest('.form__step-content').find('.list-btns a').removeClass('active-el');
                $element.addClass('active-el');

                Completude.formApply.data[$element.data('name')] = $element.data('code');
                //on défini la prochaine étape dans le bouton suivant
                let $nextBtn = $element.closest('.form__step.active').find('.btn-step-next');
                $nextBtn.data('move-to', $element.data('mapping'));

                //on renseigne la valeur dans le champ hidden pour validation du form & serialisation
                $('input[name="' + $element.data('name') + '"]').val($element.data('code'));
                Completude.formApply.data[$element.data('name')] = $element.data('code');
                this.applyLocalStorage();
                if (Completude.formApply.parsleyValidateGroup($nextBtn.data('step'))) {
                    this.moveToNext($element.data('mapping'));
                }
            },

            applyLocalStorage: function () {
                Completude.formApply.data.identity = $('[name=field-title]:checked').val();
                Completude.formApply.data.nom = $('[name=field-lastname]').val();
                Completude.formApply.data.prenom = $('[name=field-firstname]').val();
                Completude.formApply.data.birth = $('[name=field-birth-year]').val()
                    + '-' + $('[name=field-birth-month]').val()
                    + '-' + $('[name=field-birth-day]').val();
                Completude.formApply.data.nationality = $('[name=field-nationality]').val();
                Completude.formApply.data.phone = $('[name=field-phone]').val();

                if (window.autocomplete.getPlace() != undefined) {
                    Completude.SetStorage('adresse-google', window.autocomplete.getPlace());
                }


                let currentForm = Completude.formApply.$form.$element;
                Completude.formApply.data.email = $('#field-email').val();
                Completude.formApply.data.jobId = currentForm.data('id') != '' ? currentForm.data('id') : null;
                Completude.formApply.data.optin = !$('#field-terms').is(':checked');
                Completude.formApply.data.matieres = {};
                Completude.formApply.data.url = document.location.href;
                $('.mainSubject:checked').each(function (i, e) {
                    let subject = [];
                    $('.subjects_' + $(e).val() + ':checked').each(function (it, el) {
                        subject.push($(el).val());
                    });
                    Completude.formApply.data.matieres[$(e).val()] = subject;
                });
            },

            /**
             * Prérempli les champ du formulaire en fonction des données stockée en local storage
             */
            prefillForm: function () {

                // Récupère les infos saisie dans un postuler précédent
                if (null != Completude.GetStorage('form-postuler')) {
                    Completude.formApply.data = Completude.GetStorage('form-postuler');
                }


                if (!Completude.formApply.data) {
                    return;
                }
                let data = Completude.formApply.data;
                let text;

                //step Information
                if (data.birth) {
                    let birthday = data.birth.split('-')
                    jQuery('#field-birth-year').val(birthday[0]).focusout();
                    jQuery('#field-birth-month').val(birthday[1]).focusout();
                    jQuery('#field-birth-day').val(birthday[2]).focusout();
                }
                if (data.identity != undefined) {
                    jQuery('#field-title-' + (data.identity > 1 ? 'wo' : '') + 'men').click();
                }
                jQuery('#field-last-name').val(data.nom).focusout();
                jQuery('#field-firs-name').val(data.prenom).focusout();
                jQuery('#field-phone').val(data.phone).focusout();
                jQuery('#field-email').val(data.email).focusout();
                if (data.nationality !== undefined) {
                    jQuery('#field-nationality').val(data.nationality).selectric('refresh').focus().focusout();
                }



                //step Situation
                jQuery(".form__step[data-step-index=1] .list-btns a[data-code='" + data.job + "']").addClass('active-el');
                jQuery(".form__step[data-step-index=1] input[name='job']").val(data.job);
                jQuery(".form__step[data-step-index=1] .btn-step-next")
                    .data('move-to', $('.form__step[data-step-index=1] .active-el').data('mapping'));


                //step Cursus 
                let step2 = jQuery(".form__step[data-step-index=2] .list-btns a[data-code]");
                for (let p = 0; p < step2.length; p++) {
                    text = jQuery(step2[p]).data('code');
                    if (text === data.cursus) {
                        jQuery(step2[p]).addClass('active-el');
                        jQuery(".form__step[data-step-index=2] input[name='cursus']").val(data.cursus);
                        jQuery(".form__step[data-step-index=2] .btn-step-next")
                            .data('move-to', $('.form__step[data-step-index=2] .active-el').data('mapping'));
                    }
                }

                //step Preparatory-class
                let step4 = jQuery(".form__step[data-step-index=4] .list-btns a[data-preparatory]");
                for (let t = 0; t < step4.length; t++) {
                    text = jQuery(step4[t]).html();
                    if (text === data.preparatory) {
                        jQuery(step4[t]).addClass('active-el');
                        jQuery(".form__step[data-step-index=4] input[name='preparatory']").val(data.preparatory);
                        jQuery(".form__step[data-step-index=4] .btn-step-next")
                            .data('move-to', $('.form__step[data-step-index=4] .active-el').data('mapping'));
                    }
                }


                //step bac
                let step5 = jQuery(".form__step[data-step-index=5] .list-btns a[data-code]");
                for (let p = 0; p < step5.length; p++) {
                    text = jQuery(step5[p]).data('code');
                    if (text === data.bac) {
                        jQuery(step5[p]).addClass('active-el');
                        jQuery(".form__step[data-step-index=5] input[name='bac']").val(data.bac);
                        jQuery(".form__step[data-step-index=5] .btn-step-next")
                            .data('move-to', $('.form__step[data-step-index=5] .active-el').data('mapping'));
                    }
                }

                //step studies
                let step3 = jQuery(".form__step[data-step-index=3] .list-btns a[data-code]");
                for (let t = 0; t < step3.length; t++) {
                    text = jQuery(step3[t]).data('code');
                    if (text === data.lvlstudy) {
                        jQuery(step3[t]).addClass('active-el');
                        jQuery(".form__step[data-step-index=3] input[name='lvlstudy']").val(data.lvlstudy);
                        jQuery(".form__step[data-step-index=3] .btn-step-next")
                            .data('move-to', $('.form__step[data-step-index=3] .active-el').data('mapping'));
                    }
                }

                //step Degree
                let step6 = jQuery(".form__step[data-step-index=6] .list-btns a[data-code]");
                for (let t = 0; t < step6.length; t++) {
                    text = jQuery(step6[t]).data('code');
                    if (text === data.degree) {
                        jQuery(step6[t]).addClass('active-el');
                        jQuery(".form__step[data-step-index=6] input[name='degree']").val(data.degree);
                        jQuery(".form__step[data-step-index=6] .btn-step-next")
                            .data('move-to', $('.form__step[data-step-index=6] .active-el').data('mapping'));
                    }
                }

                //Choix des matieres
                for (let matiere in data.matieres) {
                    if (data.matieres[matiere].length) {
                        $('#field-' + matiere).prop("checked", true).closest('.checkbox--expand').addClass('open');
                        for (let course in data.matieres[matiere]) {
                            $('.subjects_' + matiere + '[value="' + data.matieres[matiere][course] + '"]').prop("checked", true);
                        }
                    }
                }

                $('input[name="subjectRequired"]').val($('[data-step-index="7"] input.mainSubject:checked').length);

                //step Vehicule
                let step8 = jQuery(".form__step[data-step-index=8]");
                if (data.car === 'true') {
                    step8.find("a[data-code='true']").addClass('active-el');
                    jQuery('[name="car"]').val('true');
                } else if (data.car === 'false') {
                    step8.find("a[data-code='false']").addClass('active-el');
                    jQuery('[name="car"]').val('false');
                }

                //step Contact
                // if (data.address) {
                var search_place = Completude.GetStorage('adresse-google');

                if (search_place != null && search_place != undefined && search_place != "undefined") {
                    jQuery(document).ready(function () {

                        $('#field-address').val(search_place.formatted_address).focusout();

                        setTimeout(function () {
                            window.autocomplete.set('place', search_place);
                            $('[name=field-map-lat]').val(search_place.geometry.location.lat);
                            $('[name=field-map-lng]').val(search_place.geometry.location.lng);
                            jQuery('[data-step=information]').show()
                        }, 1000);

                    });
                }
                else {
                    jQuery('[data-step=information]').show()
                }

                jQuery('#field-birth-day').on('input', function () {
                    if (jQuery(this).val().length === 2) {
                        jQuery('#field-birth-month').focus();
                    }
                });

                jQuery('#field-birth-month').on('input', function () {
                    if (jQuery(this).val().length === 2) {
                        jQuery('#field-birth-year').focus();
                    }
                })

                // Animations
                //window.handleFormItemAnimation();

                return;
            },

            /**
             * Affiche le message pour une nouvelle agence 
             */
            AffficheMessageNouvellesAgence(agence) {
                try {
                    if (Completude.settings.nouvelles_agences && agence && Completude.isNewAgence(agence.Id)) {
                        // C'est une nouvelle agence                        
                        // Affiche le message nouvelle agence
                        jQuery('.nouvelle-agence').removeClass('hide');
                    }
                }
                catch (e) {
                    console.info("Erreur dans AffficheMessageNouvellesAgence.");
                }
            }
        }
    });

})(window);

jQuery(function () {
    if (jQuery("#form-postuler").length > 0) {
        window.Completude.formApply.init();
    }
});

